const pobk = {
    validasi: {
        icon: 'check-square',
        text: 'Validasi Nilai',
        route: 'admin.classical.validation.score.material',
        role: {
            classical: ['project-owner', 'project-manager-client', 'project-owner-client', 'project-sponsor'],
        }
    }
}

export default pobk